/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import type { JiraSpaRoute, Match, RouterContext } from '@atlassian/react-resource-router';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import { ENTITY_ID, MENU_ID_ROADMAPS, MENU_ID_ROADMAPS_VIEW_ALL } from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

const routes = new Set<RouteName>(['polaris-collections']);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName = routeContext.route.name;
	const { match } = routeContext;
	const path: string[] = [MENU_ID_ROADMAPS];
	return convertRouteToPath({ routeName, match, path });
}

function convertNew(args: { routeName: RouteName; match: Match }): SelectedPath {
	const { routeName, match } = args;
	const path: string[] = [MENU_ID_ROADMAPS];
	return convertRouteToPath({ routeName, match, path });
}

function convertRouteToPath(args: {
	routeName: RouteName;
	match: Match;
	path: string[];
}): SelectedPath {
	const { routeName, match, path } = args;

	switch (routeName) {
		case 'polaris-collections': {
			const collectionId = match.params.collectionUUID;
			if (collectionId) {
				path.push(ENTITY_ID.ROADMAP(collectionId));
			} else {
				path.push(MENU_ID_ROADMAPS_VIEW_ALL);
			}
			break;
		}
		default:
	}

	return path;
}

export const roadmapsConverter: {
	routes: Set<RouteName>;
	convert: typeof convert;
	convertNew: typeof convertNew;
} = { routes, convert, convertNew };
